/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.browserModule', [])

/**
* bowser (sic) is a browser-sniffing library, installed as window.bowser.
* Define the normal default value of bowser. This is overridden in the unit test, which mocks bowser.
*/
.value('bowser', window.bowser)

/**
* bulbBrowserService encapsulates Bulb's use of bowser for browser sniffing.
* Compares current browser with list of supported browsers/versions.
*/
.service('BulbBrowserService', ['$log', '$window', 'bowser', BulbBrowserService]);

function BulbBrowserService($log, $window, bowser) {
  /**
   * List of supported browsers, with name and earliest supported version.
   * @type {object}
   *
   * FUTURE This data should be provided by the config service.
   *
   * We have decided to match our browser support with angular, which is to support the latest
   * 2 major browser versions, So when we update these browser versions, it should be done based
   * on the versions available when the angular version we support was released.  Optimally, we will
   * update these browser versions every time we update angular.
   *
   * Note: For Safari on iPad, bowser returns:
   *    {"name":"iPad","version":"8.0","webkit":true,"ipad":true,"ios":true,"osversion":"8.1","tablet":true,
   *    "a":true}
   * For Chrome on iPad, bowser returns:
   *    {"name":"Chrome","chrome":true,"version":"38.0","webkit":true,"ipad":true,"ios":true,"osversion":"8.1",
   *    "tablet":true,"a":true}
   * For Microsoft Edge, bowser returns:
   *     {"name":"Microsoft Edge","msedge":true,"version":"14.14393"}
   * Therefore, the 'chrome' entry must occur before the 'ipad' entry, so that Safari/iPad can be recognized as
   *     "ipad but not chrome."
   * Similarly, the 'chrome' entry must also occur before the 'iphone' entry, so that Safari/iPhone can be recognized
   *     as "iphone but not chrome."
   */
  this.browserInfo = {
    'firefox': {
      'name': 'Firefox',
      'version': 113
    },
    'safari': {
      'name': 'Safari',
      'version': 13
    },
    'chrome': {
      'name': 'Chrome',
      'version': 113
    },
    'ipad': {
      'name': 'Safari iPad',
      'version': 13
    },
    'iphone': {
      'name': 'Safari iPhone',
      'version': 13
    },
    'msedge' :{
      'name': 'Microsoft Edge',
      'version': 103
    }

  };

  /**
   * Map the name bowser applies to the name we'd like to use (with major version).
   */
  this.browserNames = {
    'Chrome': 'chrome',
    'ChromeHeadless': 'chromeheadless',
    'Microsoft Edge': 'msedge',
    'Firefox': 'firefox',
    'Safari': 'safari',
    'iPad': 'safari-ipad',
    'iPhone': 'safari-iphone',
    'iPod': 'safari-ipod',
    'Internet Explorer': 'ie',
    'Windows Phone': 'windows-phone',
    'Opera': 'opera',
    'Sailfish': 'sailfish',
    'SeaMonkey': 'seamonkey',
    'Amazon Silk': 'silk',
    'Android': 'android',
    'PhantomJS': 'phantomjs',
    'BlackBerry': 'blackberry',
    'WebOS': 'webos',
    'Bada': 'bada',
    'Tizen': 'tizen'
  };

  /**
   * List of allowed browser bots
   */
  this.browserBots = [
    'Googlebot',
    'bingbot',
    'Yahoo! Slurp',
    'Baiduspider'
  ];

  /**
   * Bowser considers Safari on iPad, iPhone, and iPod the "native browser" on those devices.
   * Map these names to 'safari' also.
   */
  this.safariAliases = {
    'iPad': 'safari',
    'iPhone': 'safari',
    'iPod': 'safari'
  };

  /**
   * Return true if browser is supported, based on browserInfo, else false.
   * @returns {boolean}
   */
  this.isSupported = function () {
    $log.debug('BulbBrowserService.isSupported: bowser: ' + JSON.stringify(bowser));
    for (var name in this.browserInfo) {
      if (bowser[name]) {
        // browser supported: check version
        var info = this.browserInfo[name];
        var version = parseFloat(bowser.version);
        if (isNaN(version)) {
          // cannot parse version
          $log.debug('BulbBrowserService.isSupported: info: ' + JSON.stringify(info) +
          ' cannot parse version: not supported');
          return false;
        }
        if (version >= info.version) {
          // version supported
          $log.debug('BulbBrowserService.isSupported: info: ' + JSON.stringify(info) +
          ' version supported');
          return true;
        }

        // version not supported
        $log.debug('BulbBrowserService.isSupported: info: ' + JSON.stringify(info) +
        ' version not supported');
        return false;
      }
    }

    // check for bots
    for (var i = 0; i < this.browserBots.length; i++) {
      if ($window.navigator.userAgent.search(this.browserBots[i]) >= 0) {
        return true;
      }
    }

    // browser not supported
    $log.debug('BulbBrowserService.isSupported: browser not supported');
    return false;
  };

  /**
   * Get attribute values to be set on the HTML tag from bowser attributes,
   * enabling CSS access to browser name and version.
   */
  this.getBrowserAttributes = function () {
    var attrs = [];
    var name;
    var majorVersion;
    for (var i in bowser) {
      if (bowser[i] === true) {
        if (i.match(/\b[acx]\b/)) {
          // Do not add "graded browser support" attributes,
          // for example a: true -> (nothing)
          continue;
        }
        // for example webkit: true -> 'webkit'
        attrs.push(i);
      } else if (i === 'version') {
        // for example version: 38.0 -> '38'
        majorVersion = parseInt(bowser[i], 10);
      } else if (i === 'name') {
        // for example name: 'Internet Explorer' -> 'ie'
        name = this.browserNames[bowser[i]];
        var safariAlias = this.safariAliases[bowser[i]];
        if (safariAlias) {
          // for example, if name: 'iPad', add 'safari'
          attrs.push(safariAlias);
        }
      }
    }
    // for example 'safari-ipad-8'
    if (name && majorVersion) {
      attrs.push(name + '-' + majorVersion);
    }
    return attrs.join(' ');
  };

  this.isChromeBook = function() {
      return bowser.chromeBook || false;
    };

  // FUTURE: at some point, we should have a better method of validating what browser / what device the user is using
  // and not use the userAgent string method because it is not reliable and could be easily spoofed.
  this.isMobile = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('iPad') >= 0 || ua.indexOf('iPhone') >= 0 || ua.indexOf('iPod') >= 0 ||
      ua.indexOf('Android') >= 0 || ua.indexOf('Windows Phone') >= 0;
  };

  this.isIOSMobile = function() {
    return navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPod') >= 0;
  };

  /**
   * Whether or not the user is using an iPad.
   * @returns {boolean}
   */
  this.isIpad = function() {
    return navigator.userAgent.indexOf('iPad') >= 0;
  };

  this.isAndroid = function() {
    return navigator.userAgent.indexOf('Android') >= 0;
  };

  /**
   * Checks if the device accessing the application is a windows phone.
   * @returns {boolean}
   */
  this.isWindowsMobile = function() {
    return navigator.userAgent.indexOf('Windows Phone') >= 0;
  };

  // This check wasn't as trivial as I was expecting. It is actually not that easy to determine whether or not
  // A browser is Safari just based of the userAgent String. What we actually have to do is check that the userAgent
  // Does indeed contain 'Safari' while at the same time, not including 'Chrome'. This is because Chrome will actually
  // Have both rendering engines in the user agent string. So it would return 'true' for 'isSafari' even when it is not.
  this.isSafari = function() {
    var ua = navigator.userAgent;
    // This regex uses negative look-arounds and it excludes Chrome, Edge, and all
    // Android browsers that include the Safari name in their user agent.
    // Just for reference and consistency, it would be as if we essentially wrote this:
    // return (ua.indexOf('Chrome') <= -1 && ua.indexOf('Safari') > -1);
    return (/^((?!chrome|android).)*safari/i.test(ua));
  };

  // This function checks to see if our app is running through the PWA Environment. We need this check to
  // Hide some functionality since the PWA doesn't support it yet -- i.e Google Authentication or uploading asset
  // From a user's google drive.
  this.isPWAEnvironment = function() {
    // Since a PWA is a *hosted* webapp, it is Essentially ran through a browser, MicroSoft's Edge browser, to be
    // Specific. It just has the 'feel' of a native App. With that said, there *is* a way of testing / detecting
    // Whether or not an app is running as a PWA from the navigator.userAgent string.
    // We test for the 'MSAppHost/3.0 string since this indicates that the app is
    // Running as an hosted app. I also use the Modernizer library to detect what browser it is running on
    // To make it an even more specific, explicit check.
    // That way this will *ONLY* ever get applied to the PWA, and not if the user was actually using MS Edge browser.
    // More information could be found here:
    // https://stackoverflow.com/questions/49318152/detect-if-web-app-is-running-as-pwa-through-the-microsoft-store
    var ua = navigator.userAgent;
    return (ua.indexOf('MSAppHost') > -1 && jQuery('html').attr('bulb-browser').indexOf('msedge') > -1);
  };

  /**
   * Function that checks to see if the user is using MS Edge as their browser.
   */
  this.isMsEdge = function() {
    // Identify ms edge browser
    var edgeClassic = jQuery('html').attr('bulb-browser').indexOf('msedge') > -1;
    // Identify chromium edge browser
    var edgeChromium = window.navigator.userAgent.indexOf('Edg') > -1;
    // Identify desktop app becuase
    var desktopApp = window.navigator.userAgent.indexOf('MSAppHost') > -1;

    return ((edgeClassic || edgeChromium) && !desktopApp);
  };

  /**
   * Function that checks to see if the user is using FireFox as their browser.
   * @return {boolean} Idicating whether or not they are using FireFox or not.
   */
  this.isFireFox = function() {
    return jQuery('html').attr('bulb-browser').indexOf('firefox') > -1;
  };


  // Function that checks if the user is specifically using bulb in Facebook's or Instagram's in-app 'browser'
  this.isFacebookOrInstagramInAppBrowser = function() {
    var ua = navigator.userAgent;
    return  (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) || (ua.indexOf('Instagram') > -1);
  };

  // DO LATER - JTB: Rely on Modernizr Javascript Class after Upgrading Modernizr.
  this.isTouchDevice = function() {
    return $('html').hasClass('touch');
  };

  /*
    If you long press on an element in Android, the OS will present an options menu. We don't always
    want this. If you pass in a method to this function, it will prevent the default OS options menu
    and make a call to this function pointer instead. Should only be used on Android, the method verifies
    and logs a usage error otherwise.
    WARNING: A side effect of this function is an additional touchmove/mousemove & touchend event being thrown.
    @param: callback - function var, may be initialized using .bind().
   */
  this.androidBlockAndExecuteCallbackOnOptionsMenu = function(callback) {
    if (this.isAndroid()) {
      window.oncontextmenu = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (callback !== null && callback instanceof Function) {
          callback.call();
        }
        return false;
      };
    }
  };
}

